// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Modal from 'antd/lib/modal';
import Form from 'antd/lib/form';

// EXPORTED COMPONENT
// ==========================================
class FormModal extends React.Component {
  render() {
    const { onOk, title, okText, onCancel, visible, formComponent, onSubmit } = this.props;
    return (
      <Modal title={title} onOk={onOk} okText={okText} onCancel={onCancel} visible={visible}>
        <div style={s.container}>
          <Form onSubmit={onSubmit}>{formComponent}</Form>
        </div>
      </Modal>
    );
  }
}

// STYLE
// ==========================================
const s = {
  container: {
    width: 450,
    maxWidth: '100%',
    margin: 'auto',
  },
};

// PROPS
// ==========================================
FormModal.defaultProps = {
  okText: '',
  onCancelText: '',
  title: '',
  onOk: () => {},
  visible: false,
  onCancel: () => {},
  onSubmit: () => {},
  formComponent: <div />,
};

// EXPORT
// ==========================================
export default FormModal;



// WEBPACK FOOTER //
// ./src/components/common/FormModal/index.js